<template>
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-app-bar-nav-icon @click.stop="changeDrawer()"></v-app-bar-nav-icon>
      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pl-4"
      >
        <span class="hidden-sm-and-down">Building Companee</span>
      </v-toolbar-title>
      <!--<v-text-field
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Search"
        class="hidden-sm-and-down"
      ></v-text-field>-->
      <v-spacer></v-spacer>
      <!--<v-btn icon>
        <v-icon>mdi-apps</v-icon>
      </v-btn>-->
      <!--<v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>-->
      <v-menu
        left
        bottom
        :nudge-width="300"
        origin="center center"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            large
            v-bind="attrs"
            v-on="on"
          >
              <v-icon>mdi-account</v-icon>
            
          </v-btn>
        </template>
        <v-list>
          <v-subheader>
            <v-avatar
              size="32px"
              item
            >
              <v-icon>mdi-account</v-icon>
            </v-avatar>
            <v-list-item-title class="text-h6">
              {{userLogged.username}}
            </v-list-item-title>
            <v-list-item-subtitle>{{userLogged.email}}</v-list-item-subtitle>
          </v-subheader>
          <v-divider></v-divider>
          <v-list-item-group>
            <v-list-item
              v-for="(item, i) in items"
              :key="i"
              v-on:click="open(item.route)"
            >

                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </v-app-bar>
</template>
<script>
  import router from '../router';
  import { store } from '../store';
  export default {
    props: {
      source: String,
      drawer: null,
    },
    data: () => ({
      dialog: false,
      items: [
        { text: 'Logout', icon: 'mdi-logout', route: 'Login' }
      ],
      userLogged : {},
      userLoggedPermissions : {}
    }),
    mounted () {
      this.userLogged = store.state.user;
      this.userLoggedPermissions = store.state.permissions;
    },
    methods: {
        changeDrawer(){
            this.$emit("changeDrawer", !this.drawer);
        },
        open: function(route){
          router.push({name:route});
        }
    }
  }
</script>